import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const instrumentationKey = TL_APP_INSIGHTS_KEY;
if (instrumentationKey.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) {
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey
            /* ...Other Configuration Options... */
        }
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
}
